import { formatCurrency } from '@tally/shared';

export interface CurrencyTotal {
  currency: string;
  amount: number;
}

export function formatUsd(amount: number | null | undefined): string {
  return formatCurrency(amount ?? 0, 'USD');
}

/** Local-currency amounts behind a USD total, e.g. "SGD 450.00 · ₹12,450.00"; empty when everything was in USD. */
export function localSummary(totals: CurrencyTotal[] | undefined, max = 2): string {
  const local = (totals ?? []).filter((t) => t.currency !== 'USD' && Math.abs(t.amount) >= 0.01);
  const shown = local.slice(0, max).map((t) => formatCurrency(t.amount, t.currency));
  return local.length > max ? `${shown.join(' · ')} +${local.length - max}` : shown.join(' · ');
}
